import { BaseEntity } from "./base-entity";

export class Prescription extends BaseEntity {
  PatientId: number;
  PhysicianId: number;
  Status: string;
  PrescriptionNo: number;
  IsActive: boolean;
  Signature: string;
  Comment: string;
  Class: string;
  OldStatus: string;
  IsLock: boolean;
  IsLockBy: number;
  IsReadyToCollect: boolean;
  CollectionLocation:string;
  // PharmacyId: number;
}
